exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.debug {\n\tborder:1px solid #ccc;\n\tpadding:5px;\n\tfont-family:monospace;\n\tfont-size:12px;\n\tfont-weight:bold;\n}\n.debug p {\n\tmargin-bottom:5px;\n}\n.debug p span {\n\tfont-weight:normal;\n}\n.appointment-slot {\n\tcursor:pointer;\n}\n.appointment-slot:hover {\n\tborder-color:#555;\n}\n.vc-svg-icon[data-v-63f7b5ec] {\n    color: #c1c1c1;\n}\n/*.step-7 .vc-arrows-container {\n\tdisplay:none !important;\n}*/\n", ""]);

// exports
